import { render, staticRenderFns } from "./we-expert-view.vue?vue&type=template&id=988b43e6&scoped=true&"
import script from "./we-expert-view.vue?vue&type=script&lang=js&"
export * from "./we-expert-view.vue?vue&type=script&lang=js&"
import style0 from "./we-expert-view.vue?vue&type=style&index=0&id=988b43e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b43e6",
  null
  
)

export default component.exports